module.exports = coreApis.componentApis.define;